export default "__VITE_ASSET__BrP3kmNt__"